<div class="modal-dialog" style="overflow-x: hidden;">
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCloseClick()">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="modal-header" style="border: none;">
    <h5 class="modal-title" style="width: 100%;">
      {{title}} Page
    </h5>
  </div>
  <div class="modal-content" style="background: transparent;border: none;">
    <div class="row detailer">
      <form style="width: 100%;">
        <div class="form__field">
          <input id="page__name" type="text" name="PageName" [(ngModel)]="newWP.name" matTooltipPosition="right"
            matTooltip="Page Name" class="form__input" placeholder="Page Name *">
        </div>
        <div class="form__field">
          <input id="page__url" type="text" name="URL" [(ngModel)]="newWP.url" matTooltipPosition="right"
            matTooltip="URL" class="form__input" placeholder="URL">
        </div>
        <div class="form__field">
          <input id="page__description" type="text" name="Description" [(ngModel)]="newWP.desc"
            matTooltipPosition="right" matTooltip="Description" class="form__input" placeholder="Description">
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer" style="border: none;">
    <div class="row" style="width: 100%;">
      <div class="col-6">
        <mat-error class="eror" *ngIf="newWP.name==null || newWP.name=='' ">Name is required</mat-error>
      </div>
      <div class="col-6" style="text-align: center;">
        <button mat-button [mat-dialog-close]="newWP" Primary cdkFocusInitial class="butt"
          [disabled]="newWP.name==null || newWP.name=='' ">Save</button>
        <button class="butt" mat-button [mat-dialog-close]="{deleted:1,_id:newWP._id}" Danger
          *ngIf="title==='Edit'">Delete</button>
      </div>
    </div>
  </div>
</div>